module.exports = __webpack_public_path__ + "img/bid-accolade.26b8a03b.png";